"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToApiError = void 0;
const axios_1 = __importDefault(require("axios"));
const SdPlatformErrors_1 = require("../SdPlatformErrors");
function isOAuthResponseError(response) {
    return ("error" in response) && ("error_description" in response);
}
function isResourceResponseError(response) {
    return ("error" in response) && (typeof response.error === "object") && ("message" in response.error);
}
function isValidationError(response) {
    return isResourceResponseError(response) && ("fields" in response.error);
}
function isGeometryBackendResponseError(response) {
    return ("error" in response) && ("desc" in response);
}
function period(message) {
    return message.endsWith(".") ? message : message + ".";
}
/**
 * Maps the given error into a ShapeDiver API response error object.
 */
function mapToApiError(error) {
    var _a, _b, _c, _d, _e;
    // Handle basic non-axios errors
    if (!axios_1.default.isAxiosError(error))
        return new SdPlatformErrors_1.SdPlatformError(error.message);
    const axiosError = error;
    if (axiosError.response) {
        // Request was made and server responded with 4xx or 5xx
        let data = axiosError.response.data;
        if (axiosError.response.status >= 500) {
            // TODO Alex: shouldn't it be data?.message here?
            return new SdPlatformErrors_1.SdPlatformServerResponseError((_b = (_a = data === null || data === void 0 ? void 0 : data.error) === null || _a === void 0 ? void 0 : _a.message) !== null && _b !== void 0 ? _b : "Server Error.", axiosError.response.status);
        }
        else if (data && isOAuthResponseError(data)) {
            if (data.error == "invalid_client") {
                return new SdPlatformErrors_1.SdPlatformInvalidClientOAuthResponseError(`${period(data.error)} ${period(data.error_description)}`, axiosError.response.status, data.error, data.error_description, data.error_uri);
            }
            else if (data.error == "invalid_request") {
                return new SdPlatformErrors_1.SdPlatformInvalidRequestOAuthResponseError(`${period(data.error)} ${period(data.error_description)}`, axiosError.response.status, data.error, data.error_description, data.error_uri);
            }
            else if (data.error == "invalid_grant") {
                return new SdPlatformErrors_1.SdPlatformInvalidGrantOAuthResponseError(`${period(data.error)} ${period(data.error_description)}`, axiosError.response.status, data.error, data.error_description, data.error_uri);
            }
            else if (data.error == "unauthorized_client") {
                return new SdPlatformErrors_1.SdPlatformUnauthorizedClientOAuthResponseError(`${period(data.error)} ${period(data.error_description)}`, axiosError.response.status, data.error, data.error_description, data.error_uri);
            }
            else if (data.error == "unsupported_grant_type") {
                return new SdPlatformErrors_1.SdPlatformUnsupportedGrantTypeClientOAuthResponseError(`${period(data.error)} ${period(data.error_description)}`, axiosError.response.status, data.error, data.error_description, data.error_uri);
            }
            return new SdPlatformErrors_1.SdPlatformOAuthResponseError(`${period(data.error)} ${period(data.error_description)}`, axiosError.response.status, data.error, data.error_description, data.error_uri);
        }
        else if (data && isResourceResponseError(data)) {
            if (isValidationError(data)) {
                const fields = Object.entries(data.error.fields).reduce((acc, [key, value]) => {
                    acc[key] = Array.isArray(value) ? value : [value];
                    return acc;
                }, {});
                const fieldsMessage = Object.values(fields).map((msgs) => msgs.map(m => period(m)).join(" ")).join(" ");
                const message = `${period(data.error.message)} ${period(data.error.description)}`;
                return new SdPlatformErrors_1.SdPlatformValidationResponseError(fieldsMessage ? `${message} ${fieldsMessage}` : message, axiosError.response.status, data.error.message, data.error.description, data.error.href, data.error.code, fields);
            }
            switch (axiosError.response.status) {
                case 404:
                    return new SdPlatformErrors_1.SdPlatformNotFoundResponseError(`${period(data.error.message)} ${period(data.error.description)}`, axiosError.response.status, data.error.message, data.error.description, data.error.href, data.error.code);
                case 403:
                    return new SdPlatformErrors_1.SdPlatformForbiddenResponseError(`${period(data.error.message)} ${period(data.error.description)}`, axiosError.response.status, data.error.message, data.error.description, data.error.href, data.error.code);
                case 401:
                    return new SdPlatformErrors_1.SdPlatformUnauthorizedResponseError(`${period(data.error.message)} ${period(data.error.description)}`, axiosError.response.status, data.error.message, data.error.description, data.error.href, data.error.code);
                default:
                    return new SdPlatformErrors_1.SdPlatformResourceResponseError(`${period(data.error.message)} ${period(data.error.description)}`, axiosError.response.status, data.error.message, data.error.description, data.error.href, data.error.code);
            }
        }
        else if (data && isGeometryBackendResponseError(data)) {
            return new SdPlatformErrors_1.SdPlatformGeometryBackendResponseError(data.message || (data.desc || ((_c = data.error) !== null && _c !== void 0 ? _c : "")), (_d = data.error) !== null && _d !== void 0 ? _d : "", (_e = data.desc) !== null && _e !== void 0 ? _e : "");
        }
        else {
            // Response was made but an unknown error object was received
            return new SdPlatformErrors_1.SdPlatformError("");
        }
    }
    else if (axiosError.request) {
        // The request was made but no response was received.
        // We can do something with `error.request`.
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js.
        return new SdPlatformErrors_1.SdPlatformRequestError("Could not send request.", "The request was made but no response was received.");
    }
    else {
        // Something happened in setting up the request that triggered an Error
        return new SdPlatformErrors_1.SdPlatformError(error.message);
    }
}
exports.mapToApiError = mapToApiError;
//# sourceMappingURL=SdPlatformSdkErrorMapping.js.map